import { useEffect } from 'react';
import * as microsoftTeams from '@microsoft/teams-js';

const MicrosoftLoginConsentEnd = () => {
    useEffect(() => {
        microsoftTeams.initialize();

        try {
            console.log("end page 2");
            microsoftTeams.getContext((context) => {
                console.log("context:", context)
                microsoftTeams.authentication.notifySuccess();
            });
        } catch (error) {
            console.log("error:", error)
            microsoftTeams.authentication.notifyFailure(error.message || "An error occurred");
        }
    }, []);

    return (
        <div className="ms-Fabric">
            <div id="content">
                <p>You have returned from Azure AD</p>
            </div>
        </div>
    );
};

export default MicrosoftLoginConsentEnd;
